
    <template>
      <section class="content element-doc">
        <h2 id="popconfirmdelbutton-qi-pao-que-ren-shan-chu-an-niu"><a class="header-anchor" href="#popconfirmdelbutton-qi-pao-que-ren-shan-chu-an-niu">¶</a> PopconfirmDelButton 气泡确认删除按钮</h2>
<h3 id="ji-chu-yong-fa"><a class="header-anchor" href="#ji-chu-yong-fa">¶</a> 基础用法</h3>
<p>基础属性和使用方法参考 <a href="https://element.eleme.cn/#/zh-CN/component/popconfirm">element-ui </a> <code>popconfirm</code> 组件文档。</p>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;ShPopDelButton @confirm=&quot;onConfirm&quot; :loading=&quot;btnLoading&quot; :btnIcon=&quot;'el-icon-delete'&quot;&gt; &lt;/ShPopDelButton&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        btnLoading: false
      }
    },
    methods: {
      onConfirm() {
        this.btnLoading = true
        setTimeout(() =&gt; {
          this.btnLoading = false
        }, 2000)
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="zi-ding-yi-nei-rong"><a class="header-anchor" href="#zi-ding-yi-nei-rong">¶</a> 自定义内容</h3>
<p>通过 <code>slot</code> 可以自定义 Popconfirm 的内容。el-button 相关的 Attributes 不在生效</p>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div&gt;
    &lt;ShPopDelButton title=&quot;自定义提示文本&quot; @confirm=&quot;onConfirm&quot; :loading=&quot;btnLoading&quot; :btnIcon=&quot;'el-icon-delete'&quot;&gt;
      &lt;template #reference&gt;
        &lt;el-button type=&quot;text&quot; :loading=&quot;btnLoading&quot;&gt;删除&lt;/el-button&gt;
      &lt;/template&gt;
    &lt;/ShPopDelButton&gt;
    &lt;/ShPopDelButton&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  export default {
    data() {
      return {
        btnLoading: false
      }
    },
    methods: {
      onConfirm() {
        this.btnLoading = true
        setTimeout(() =&gt; {
          this.btnLoading = false
        }, 2000)
      }
    }
  }
&lt;/script&gt;

&lt;style&gt;&lt;/style&gt;
</code></pre></template></demo-block><h3 id="attributes"><a class="header-anchor" href="#attributes">¶</a> Attributes</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>提示文本</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>confirm-button-text</td>
<td>确认按钮文本</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>cancel-button-text</td>
<td>取消按钮文本</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>confirm-button-type</td>
<td>确认按钮类型</td>
<td>string</td>
<td>与 el-button 相同</td>
<td>primary</td>
</tr>
<tr>
<td>cancel-button-type</td>
<td>取消按钮类型</td>
<td>string</td>
<td>与 el-button 相同</td>
<td>text</td>
</tr>
<tr>
<td>icon</td>
<td>Popover 图标</td>
<td>string</td>
<td>-</td>
<td>el-icon-question</td>
</tr>
<tr>
<td>icon-color</td>
<td>Popover 图标颜色</td>
<td>string</td>
<td>-</td>
<td>#f90</td>
</tr>
<tr>
<td>hide-icon</td>
<td>是否隐藏图标</td>
<td>boolean</td>
<td>true,false</td>
<td>false</td>
</tr>
<tr>
<td>btn-icon</td>
<td>默认按钮图标</td>
<td>string</td>
<td>-</td>
<td>-</td>
</tr>
<tr>
<td>btn-type</td>
<td>默认按钮类型</td>
<td>string</td>
<td>与 el-button 相同</td>
<td>danger</td>
</tr>
<tr>
<td>btn-size</td>
<td>默认按钮大小</td>
<td>string</td>
<td>与 el-button 相同</td>
<td>small</td>
</tr>
<tr>
<td>loading</td>
<td>按钮加载状态</td>
<td>boolean</td>
<td>true,false</td>
<td>false</td>
</tr>
</tbody>
</table>
<h3 id="events"><a class="header-anchor" href="#events">¶</a> Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>confirm</td>
<td>点击确认按钮时</td>
<td>-</td>
</tr>
<tr>
<td>cancel</td>
<td>点击取消按钮时</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="slot"><a class="header-anchor" href="#slot">¶</a> Slot</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>reference</td>
<td>触发 Popconfirm 显示的 HTML 元素</td>
<td>参考示例</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ShPopDelButton',{attrs:{"loading":_vm.btnLoading,"btnIcon":'el-icon-delete'},on:{"confirm":_vm.onConfirm}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        btnLoading: false
      }
    },
    methods: {
      onConfirm() {
        this.btnLoading = true
        setTimeout(() => {
          this.btnLoading = false
        }, 2000)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('ShPopDelButton',{attrs:{"title":"自定义提示文本","loading":_vm.btnLoading,"btnIcon":'el-icon-delete'},on:{"confirm":_vm.onConfirm},scopedSlots:_vm._u([{key:"reference",fn:function(){return [_c('el-button',{attrs:{"type":"text","loading":_vm.btnLoading}},[_vm._v("删除")])]},proxy:true}])})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
    data() {
      return {
        btnLoading: false
      }
    },
    methods: {
      onConfirm() {
        this.btnLoading = true
        setTimeout(() => {
          this.btnLoading = false
        }, 2000)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  